import React, { useContext } from 'react'
import PropTypes from 'prop-types'

import PriceField from 'components/Forms/FormElements/PriceField'
import EventFormModule from 'components/Events/EventForm/EventFormModules/EventFormModule'
import CompactFormRow from 'components/Forms/CompactForm/CompactFormRow/CompactFormRow'
import { ExtendedFormikContext } from 'components/Forms/ExtendedFormik'

const EventFormPriceFieldModule = ({
    name,
    label,
    placeholder,
    unitsTip,
    tipText,
    icon,
    className,
    onChange,
    onBlur,
    decimals,
    onFocus
}) => {
    const { setFieldValue, extendedActions } = useContext(ExtendedFormikContext)

    return (
        <EventFormModule className={className}>
            <CompactFormRow
                iconName={icon}
                label={label}
                trackName={name}
            >
                <PriceField
                    name={name}
                    placeholder={placeholder}
                    unitsTip={unitsTip}
                    size="s"
                    tip={tipText}
                    decimals={decimals}
                    setFieldValue={setFieldValue}
                    manipulateField={extendedActions.manipulateField}
                    onChange={onChange}
                    onBlur={onBlur}
                    onFocus={onFocus}
                />
            </CompactFormRow>
        </EventFormModule>
    )
}

EventFormPriceFieldModule.propTypes = {
    className: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    unitsTip: PropTypes.string,
    icon: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    decimals: PropTypes.number,
    onFocus: PropTypes.func,
}

EventFormPriceFieldModule.defaultValues = {
    decimals: 2,
}

export default EventFormPriceFieldModule
